//export const environment = {
  //production: false,
 // hmr: true,
//servralUrl: 'https://booksapi.zynobooks.com',
    //  servralUrl: 'http://192.168.20.188:4000',  // Prabhakar    
  // servralUrl: 'http://192.168.20.49:4000',  // suflesh    
  // servralUrl: 'http://192.168.20.24:4000',  // shivam   
  // servralUrl: 'https://mertesackerapi.elitetraveltech.in',  // development
      
  //  servralUrl: 'http://localhost:9900', // local
    //zatca_base:'https://dotnetapi.zynoretail.com',
  //fileUrl: 'http://192.168.20.245:5000/uploadDoc/',
  // fileUrl: 'https://mertesackerapi.elitetraveltech.in/uploadDoc/',

  //baseHref: 'http://localhost:4200/',
  // baseHref: 'https://mertesackerapi.elitetraveltech.in/',
//};   


export const environment = {
  production: false,
  hmr: true,
  servralUrl: '',
  servralUrlAI: '',
  defaultLanguage: '',
  projecticon:'',
  adminservralUrl: '',
  supportedLanguages: [],
   baseHref: 'https://mertesackerapi.elitetraveltech.in/',
  zatca_base:'https://dotnetapi.zynoretail.com',
  fileUrl:'',
};
